module.exports = __webpack_public_path__ + "static/media/minganci1.4ee3ea2f.jpg";